import {
  Page,
  Header,
  Link,
  Content,
  TableColumn,
  Table,
} from "@backstage/core-components";
import { useApi } from "@backstage/core-plugin-api";
import { useIsAdmin } from "@internal/plugin-admin-panel";
import { Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { opsReviewApiRef } from "../../api/OpsReviewApi";
import { TeamSelect } from "../../components/OwnershipSection/TeamSelect";
import { ArchivedCheckbox } from "./ArchivedCheckbox";

interface Props {}

export const OwnershipEditor: React.FC<Props> = (): JSX.Element => {
  const isAdmin = useIsAdmin();
  const api = useApi(opsReviewApiRef);
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    (async () => {
      setData((await api.listOwnership()).data);
    })();
  }, [api, setData]);

  if (!isAdmin) {
    return (
      <Page themeId="tool">
        <Header title="OpsReview Ownership Editor" />
        <Content>
          <Typography>
            Please speak with a{" "}
            <Link to="/catalog/default/Group/internal-platform-and-automation">
              Radiator admin
            </Link>{" "}
            to change ownership
          </Typography>
        </Content>
      </Page>
    );
  }

  const columns: TableColumn<any>[] = [
    {
      title: "Repo",
      field: "repo",
      render: (rowData) => {
        return (
          <a href={rowData.link} target="_blank">
            {rowData.repo}
          </a>
        );
      },
    },
    {
      title: "Team",
      field: "team",
      render: (rowData) => {
        return (
          <TeamSelect
            repo={rowData.repo}
            defaultValue={rowData.team}
            link={rowData.link}
          />
        );
      },
    },
    {
      title: "Archived",
      field: "archived",
      render: (rowData) => {
        return <ArchivedCheckbox data={rowData} />;
      },
    },
  ];

  const jsx = (
    <Table
      options={{
        sorting: false,
        search: true,
        paging: true,
        pageSize: 50,
        padding: "dense",
      }}
      columns={columns}
      data={data}
    />
  );

  return (
    <Page themeId="tool">
      <Header title="OpsReview Ownership Editor" />
      <Content>{jsx}</Content>
    </Page>
  );
};
